import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=f6123574&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=ts&"
export * from "./InputText.vue?vue&type=script&lang=ts&"
import style0 from "./InputText.vue?vue&type=style&index=0&id=f6123574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6123574",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
